function customRound(value: number, digits = 4) {
  const factor = Math.pow(10, digits);
  const n = Math.floor(+value * factor * 10) / 10;

  return (Math.round(n) / factor).toFixed(digits);
}

export { customRound };
